// extracted by mini-css-extract-plugin
export default {"icon":"Expand_icon__dKHLu"};